document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.product-slider');

  sliders.forEach((slider, index) => {
    let position = 0;
    const groups = slider.querySelectorAll('.product-group');
    const sliderContainer = slider.closest('.slider-container');
    let groupWidth = 0;
    const totalGroups = groups.length;
    const maxPosition = totalGroups - 1;

    const collectionColumn = sliderContainer.closest('.collection-column');
    const leftBtn = collectionColumn.querySelector(`.slide-left[data-target="slider-${index}"]`);
    const rightBtn = collectionColumn.querySelector(`.slide-right[data-target="slider-${index}"]`);

    function setGroupWidths() {
      const containerWidth = sliderContainer.offsetWidth;
      groupWidth = containerWidth;

      groups.forEach(group => {
        group.style.minWidth = `${containerWidth}px`;
        group.style.maxWidth = `${containerWidth}px`;
      });

      updateSlider();
    }

    function updateSlider() {
      slider.style.transform = `translateX(-${position * groupWidth}px)`;

      if (leftBtn) {
        leftBtn.classList.toggle('disabled', position === 0);
      }
      if (rightBtn) {
        rightBtn.classList.toggle('disabled', position === maxPosition);
      }
    }

    if (leftBtn && rightBtn) {
      leftBtn.addEventListener('click', () => {
        if (position > 0) {
          position--;
          updateSlider();
        }
      });

      rightBtn.addEventListener('click', () => {
        if (position < maxPosition) {
          position++;
          updateSlider();
        }
      });
    }

    setGroupWidths();
    window.addEventListener('resize', setGroupWidths);

    // === Touch-свайп ===
    let touchStartX = 0;
    let touchEndX = 0;
    const swipeThreshold = 50;

    slider.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
    });

    slider.addEventListener('touchmove', (e) => {
      touchEndX = e.touches[0].clientX;
    });

    slider.addEventListener('touchend', () => {
      const deltaX = touchEndX - touchStartX;

      if (Math.abs(deltaX) > swipeThreshold) {
        if (deltaX < 0 && position < maxPosition) {
          position++;
          updateSlider();
        } else if (deltaX > 0 && position > 0) {
          position--;
          updateSlider();
        }
      }
      touchStartX = 0;
      touchEndX = 0;
    });
  });

  // Добавление товара в корзину
  window.addToCart = function(button) {
    const form = button.closest('.add-to-cart-form');
    const variantId = form.getAttribute('data-variant-id');
    const quantity = 1;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(response => {
      if (response.ok) {
        const cartNotification = document.querySelector('.cart-notification');
        if (cartNotification) {
          cartNotification.classList.add('active');
          setTimeout(() => cartNotification.classList.remove('active'), 3000);
        }
      } else {
        console.error('Ошибка при добавлении в корзину');
      }
    })
    .catch(error => {
      console.error('Ошибка:', error);
    });
  };
});
